import React from "react";
import { Button, Icon } from "@caesars-ui/core";
import { navigate } from "gatsby";

export const Header = () => {
    return (<div className="flex items-center justify-start gap-2 lg:gap-4">
        <div className="grow"></div>
        <Button type="tertiary" onClick={() => navigate("/help-feedback")} leftIcon={<Icon name="ui_question" size="md" />} aria-label="Help & Feedback" />
        <Button type="primary" onClick={() => navigate("/getting-started")}>Get Started</Button>
    </div>)
}


export default Header;